import { buildModelManager } from "../builder.js";
const DefaultCustomCouponCodeUsedSelection = {
  __typename: true,
  id: true,
  code: true,
  contactId: true,
  createdAt: true,
  customerId: true,
  expiredAt: true,
  updatedAt: true,
  usedAt: true
};
const modelApiIdentifier = "customCouponCodeUsed";
const pluralModelApiIdentifier = "customCouponCodeUseds";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCustomCouponCodeUsedSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCustomCouponCodeUsedSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCustomCouponCodeUsedSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCustomCouponCodeUsedSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCustomCouponCodeUsedSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCustomCouponCodeUsedSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCustomCouponCodeUsedSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByCode",
    findByField: "code",
    findByVariableName: "code",
    modelApiIdentifier,
    defaultSelection: DefaultCustomCouponCodeUsedSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByCode",
    findByField: "code",
    findByVariableName: "code",
    modelApiIdentifier,
    defaultSelection: DefaultCustomCouponCodeUsedSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createCustomCouponCodeUsed",
    operationReturnType: "CreateCustomCouponCodeUsed",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      customCouponCodeUsed: { required: false, type: "CreateCustomCouponCodeUsedInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCustomCouponCodeUsedSelection
  },
  {
    type: "action",
    operationName: "bulkCreateCustomCouponCodeUseds",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateCustomCouponCodeUsedsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultCustomCouponCodeUsedSelection
  },
  {
    type: "action",
    operationName: "updateCustomCouponCodeUsed",
    operationReturnType: "UpdateCustomCouponCodeUsed",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      customCouponCodeUsed: { required: false, type: "UpdateCustomCouponCodeUsedInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCustomCouponCodeUsedSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateCustomCouponCodeUseds",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateCustomCouponCodeUsedsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultCustomCouponCodeUsedSelection
  },
  {
    type: "action",
    operationName: "deleteCustomCouponCodeUsed",
    operationReturnType: "DeleteCustomCouponCodeUsed",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteCustomCouponCodeUseds",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertCustomCouponCodeUsed",
    operationReturnType: "UpsertCustomCouponCodeUsed",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      customCouponCodeUsed: { required: false, type: "UpsertCustomCouponCodeUsedInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateCustomCouponCodeUsedResult": { hasReturnType: false },
      "... on UpdateCustomCouponCodeUsedResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCustomCouponCodeUsedSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertCustomCouponCodeUseds",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertCustomCouponCodeUsedsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultCustomCouponCodeUsedSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "customCouponCodeUsedGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const CustomCouponCodeUsedManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultCustomCouponCodeUsedSelection,
  operations
);
export {
  CustomCouponCodeUsedManager,
  DefaultCustomCouponCodeUsedSelection
};
//# sourceMappingURL=CustomCouponCodeUsed.js.map
